<img
  [src]="imageUrl"
  [width]="imageWidth"
  [height]="imageHeight"
  alt="lcss-logo"
/>
